import { Box } from "@mui/material";
import BookContent from "./components/bookContent";

const bookConnectPage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <BookContent />
    </Box>
  );
};

export default bookConnectPage;
